import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class ApplicationRepository extends Base2Repository {
  getEntityIdentifier() {
    return "application";
  }

  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({
      fetch: "/v1/applications",
      create: "/v1/applications",
      delete: "/v1/applications"
    });
  }
}

export default new ApplicationRepository();



// WEBPACK FOOTER //
// ./src/core/repository/application.repository.js